import { render, staticRenderFns } from "./PostsContainer.vue?vue&type=template&id=28e7a656&"
import script from "./PostsContainer.vue?vue&type=script&lang=ts&"
export * from "./PostsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports